import { type I18n, type Composer, createI18n } from "vue-i18n";

import { LocalStorageService } from "@/Services/LocalStorageService";
import { Language } from "@/Common/Models/Domain/Language";

import { normalizeLanguage } from "@/Utils/Language";
import { LANG_STORAGE_KEY, LOCALE_STORAGE_SERVICE } from "@/Modules/i18n/Model/Constants";
import { baseTranslations } from "@/Modules/i18n/base";

export interface LocalI18n extends I18n {
  global: Composer;
}

const localStorageService = new LocalStorageService(LOCALE_STORAGE_SERVICE);
const localStorageLang: string = localStorageService.get(LANG_STORAGE_KEY);
const lang = normalizeLanguage(localStorageLang) ?? normalizeLanguage(navigator.language) ?? Language.ENGLISH;

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: lang || "en",
  fallbackLocale: "en",
  messages: baseTranslations,
}) as unknown as LocalI18n;
